import { observable, action, runInAction } from 'mobx';
import { RootStore } from '..';
import { fetchWrapper } from '../../common/Fetch';
import { formatDateJson } from '../../common/Formatting';

export interface Report2Data {
    items: Report2Item[];
}


export interface Report2Item {
    date: Date;
    ordersCount: number;
    positionsCount: number;
    saleSum: number;
    purchaseSum: number;
}



export class Report2Store {

    _rootStore: RootStore;

    @observable items: Report2Item[] = [];


    constructor(rootStore: RootStore) {
        this._rootStore = rootStore;
    }


    @action
    loadData(statuses: number[], dateFrom?: Date, dateTo?: Date) {
        this.items = [];
        const statusesParam = statuses.length <= 0 ? "" : "&statuses=" + statuses.join("&statuses=");
        const dateFromStr = dateFrom == undefined ? '' : formatDateJson(dateFrom);
        const dateToStr = dateTo == undefined ? '' : formatDateJson(dateTo);

        fetchWrapper(`api/report2/getdata?dateFrom=${dateFromStr}&dateTo=${dateToStr}${statusesParam}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }, this._rootStore.commonStore)
            .then(res => res.json() as Promise<Report2Item[]>)
            .then(result => {
                runInAction("fetch complete loadData", () => {
                    this.items = result;
                });
            })
            .catch(res => {
                console.log(res);
            });
    }

}